
import { Component, Mixins } from "vue-property-decorator";
import { default as ForegroundDrawableObjectMixin } from "./ForegroundDrawableObjectMixin.vue";
import { default as StyledDrawableMixin } from "./StyledDrawableMixin.vue";

@Component
export default class StyledDrawableObjectMixin extends Mixins(
  ForegroundDrawableObjectMixin,
  StyledDrawableMixin
) {
}
